import { render } from "./Modal.vue?vue&type=template&id=25e869fb"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mathe\\Desktop\\matheogirard.fr\\front-pi_air-v2.matheogirard.fr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__